import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ConnectingAirportsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"connecting_airports"}/>
}
